// [uTheory](http://utheory.com) - Copyright (c) Gregory Ristow 2014
//
// ## Sort accidentals by +/- half-step changes
//
// Include description of object & useful info here, please!
import InteractivePrototype from './interactivePrototype.ts';
import utils from '../utils.ts';
import CheckMark from './checkMark.ts';
import ListSorter from './tableListSorter.ts';

const settings = {
  instructions: true,
  letters: {
    checkButton: true,
    letterButtons: false,
  },
  progressTracker: true,
  checkMark: {},
};

const layout = {
  letters: { percent: 10 },
};

export default class SeventhChordSorter extends InteractivePrototype {
  // Public constructor
  constructor(displayDiv, options) {
    super();
    this.settings = utils.clone(settings);
    this.layout = utils.clone(layout);
    this.init(displayDiv, options);
  }

  // Overriding these methods / properties:

  init(displayDiv, options) {
    // now call the prototype's init function:
    super.init(displayDiv, options).then(() => {
      this.progressTracker.start();
      this.letterPanel.addCheckCallback(this.checkAnswer, this);
      this.attempts = 0;
    });
  }

  displayInstructions() {
    this.instructionsDiv.innerHTML = 'Match the qualities & symbols to the seventh chord type.';
  }

  createCustomDivs() {
    this.createDiv('listDiv', { width: '100%', height: 'auto' });
    this.displayDiv.removeChild(this.listDiv);
    this.displayDiv.insertBefore(this.listDiv, this.lettersDiv);
    this.checkMark = new CheckMark(this.listDiv);
  }

  initializeCustomElements() {
    const circleSlash = String.fromCharCode(248);
    const triangle = String.fromCharCode(9651);
    const half = String.fromCharCode(189);

    const grid = [
      ['Quality:', 'Abbreviation:', 'Symbol:', 'Triad Quality:', '7th Quality:'],
      ['Major 7', 'M7', triangle, 'Major', 'Major'],
      ['minor 7', 'm7', '-7', 'minor', 'minor'],
      ['diminished 7', 'dim7', 'o7', 'dim', 'dim'],
      ['half-diminished 7', `${half}-dim7`, `${circleSlash}7`, 'dim', 'minor'],
      ['Dominant 7', 'Dom7', '7', 'Major', 'minor'],
    ];

    const lists = grid.reduce(
      ([types, abbrevs, symbols, triads, sevenths], [type, abbrev, symbol, triad, seventh]) => {
        types.push(type);
        abbrevs.push(abbrev);
        symbols.push(symbol);
        triads.push(triad);
        sevenths.push(seventh);
        return [types, abbrevs, symbols, triads, sevenths];
      },
      [[], [], [], [], []]
    );

    this.listSorter = new ListSorter(this.listDiv, lists);
    this.layout.sortDiv = {
      div: this.listDiv,
      visible: true,
      percent: 85,
      callback: this.listSorter.resize.bind(this.listSorter),
    };
  }

  gameOver() {
    this.lettersDiv.style.display = 'none';
    this.listSorter.gameOver();
    super.gameOver();
  }

  exit() {
    this.listSorter?.gameOver();
    super.exit();
  }

  checkAnswer(rightBoolean) {
    this.attempts++;
    let answers = this.listSorter.check();
    if (typeof rightBoolean !== 'undefined') {
      answers = rightBoolean ? { right: 10, wrong: 0 } : { wrong: 10, right: 0 };
    }
    const gameOver = answers.wrong === 0;
    this.progressTracker.multipleAnswers(
      [
        {
          skill: 'seventh_chord_types',
          right: answers.right,
          wrong: answers.wrong,
          questions: answers.right + answers.wrong,
        },
      ],
      answers.right + answers.wrong,
      gameOver
    );
    if (gameOver) {
      this.checkMark.check(2);
      this.gameOver();
    } else {
      this.checkMark.x();
      if (this.attempts > 1) this.listSorter.hint();
    }
  }

  debugRightAnswer() {
    this.checkAnswer(true);
  }

  debugWrongAnswer() {
    this.checkAnswer(false);
  }
}

SeventhChordSorter.registry = {
  description: 'Chord Quality Matching',
  skills: ['seventh_chord_types'],
};
